import { IRoamingInternationalCountry } from "@nju/data-access-portal-dashboard";
import { IOffer } from "@nju/data-access-portal-offers";
import { Separator } from "@nju/ui";
import { Packages } from "../packages";
import { SelectedCountryDetails } from "../partials";
import { IButtonType, IFilteredOffer, IPackageType } from "../types";

interface IOfferStandardProps {
  roamingOffers: IFilteredOffer;
  selectedCountry: IRoamingInternationalCountry;
  selectedVoicePackage: IOffer | undefined;
  selectedDataPackage: IOffer | undefined;
  onSelectVoicePackage: (type: IButtonType, packageType: IPackageType) => void;
  onSelectDataPackage: (type: IButtonType, packageType: IPackageType) => void;
}

export function OfferStandard({
  roamingOffers,
  selectedCountry,
  selectedVoicePackage,
  selectedDataPackage,
  onSelectVoicePackage,
  onSelectDataPackage,
}: IOfferStandardProps) {
  return (
    <>
      <SelectedCountryDetails selectedCountry={selectedCountry} />
      <Separator size="m" />
      <Packages
        offers={roamingOffers}
        onSelectDataPackage={onSelectDataPackage}
        onSelectVoicePackage={onSelectVoicePackage}
        packageType="STANDARD"
        selectedDataPackage={selectedDataPackage}
        selectedVoicePackage={selectedVoicePackage}
      />
    </>
  );
}
